import { connect, MapStateToProps } from 'react-redux';
import { getTagsForDeviationId } from '../../../../selectors/studio';
import { AppState } from '../../../../types/store';
import { Props } from './DeviationTags';

export type StateProps = Pick<Props, 'tags'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  { deviation }
) => ({
  tags: getTagsForDeviationId(state, deviation.deviationId),
});

export default connect(mapStateToProps);
